import React, { useState, useEffect } from 'react';
import { adService } from '../services/api';

const AdSlot = ({ position, className = "" }) => {
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAd();
  }, [position]);

  const loadAd = async () => {
    try {
      const response = await adService.index({ 
        position, 
        active_only: 1,
        approval_status: 'approved',
        payment_status: 'paid'
      });
      const ads = response.data || response;
      if (ads && ads.length > 0) {
        // Pick a random ad if multiple are available for the slot
        const randomAd = ads[Math.floor(Math.random() * ads.length)];
        setAd(randomAd);
        // Track impression
        adService.trackImpression(randomAd.id);
      }
    } catch (error) {
      console.error(`Error loading ad for ${position}:`, error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    if (ad) {
      adService.trackClick(ad.id);
    }
  };

  if (loading || !ad) return null;

  return (
    <div className={`ad-slot relative overflow-hidden rounded-xl border border-slate-200 bg-slate-50 ${className}`}>
      <div className="absolute top-2 right-2 z-10">
        <span className="bg-white/90 backdrop-blur-sm text-[9px] font-black uppercase tracking-widest px-2 py-1 rounded text-slate-500 border border-slate-200 shadow-sm">
          Sponsored
        </span>
      </div>
      <a 
        href={ad.link_url} 
        target="_blank" 
        rel="noopener noreferrer" 
        onClick={handleClick}
        className="block group"
      >
        <div className="relative overflow-hidden">
          <img 
            src={ad.image_url} 
            alt={ad.title} 
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          {ad.type === 'native' && (
            <div className="p-4 bg-white">
              <h4 className="text-sm font-bold text-slate-900 mb-1 group-hover:text-red-600 transition-colors">
                {ad.title}
              </h4>
              {ad.description && (
                <p className="text-xs text-slate-500 line-clamp-2 leading-relaxed">
                  {ad.description}
                </p>
              )}
            </div>
          )}
        </div>
      </a>
    </div>
  );
};

export default AdSlot;
